import { FC } from 'react'
import { useCustomTheme } from '@atbay/theming'
import Typography from '@/ui/components/typography'
import { EmptyStateWrapper } from './BecIssuesTableEmptyState.styles'

const BecIssuesTableEmptyState: FC = () => {
    const theme = useCustomTheme()

    return (
        <EmptyStateWrapper data-testid="bec-issues-empty-state">
            <Typography variant="m-regular" color={theme.colors.greys[500]}>
                No open issues
            </Typography>
        </EmptyStateWrapper>
    )
}

export default BecIssuesTableEmptyState
